import React, { useCallback, useEffect, useMemo, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Button } from "reactstrap"
import { FilterData, IndexType } from "components/Extra"
import CouponsTable from "pages/admin/Coupons/CouponsTable"
import { CouponsGrid } from "pages/admin/Coupons/CouponsGrid"
import { AddNewCoupon, PendingApprovalModal } from "pages/admin/Coupons/Modals"
import { useNavigate } from "react-router-dom"
import { AddNewOffer } from "pages/admin/Offers/Modals/AddNewOffer/AddNewOffer"
import { AddNewCampaign } from "pages/admin/Campaigns/Modals/AddNewCampaign"
import { AssignDeliveryManModal } from "pages/admin/Orders/Modals/AssignDeliveryManModal"
import { useTranslation } from "react-i18next"

export type Coupon = {
  id: string
  name: string
  count: number
  price: string
  productSize: string
  refillTimes: string
  itemPerRefill: string
  status: "Active" | "In Active" | "Pending Approval"
  customer: string
}

interface CouponsProps {
  isDashboardPage?: boolean
}

const couponsData: Coupon[] = [
  {
    id: "ID-145871",
    name: "Coupons Name",
    count: 10,
    price: "100",
    productSize: "Gallon",
    refillTimes: "3 Days/Week",
    itemPerRefill: "1 Gallon/Once",
    status: "Active",
    customer: "Customer Name",
  },
  {
    id: "ID-145872",
    name: "Coupons Name",
    count: 15,
    price: "50",
    productSize: "Bottle 1.5 L",
    refillTimes: "2 Days/Week As",
    itemPerRefill: "3 Bottle/Once",
    status: "Active",
    customer: "Customer Name",
  },
  {
    id: "ID-145873",
    name: "Coupons Name",
    count: 10,
    price: "100",
    productSize: "Gallon",
    refillTimes: "3 Days/Week",
    itemPerRefill: "1 Gallon/Once",
    status: "In Active",
    customer: "Customer Name",
  },
  {
    id: "ID-145874",
    name: "Coupons Name",
    count: 10,
    price: "50",
    productSize: "Bottle 1.5 L",
    refillTimes: "2 Days/Week As",
    itemPerRefill: "3 Bottle/Once",
    status: "Active",
    customer: "Customer Name",
  },
  {
    id: "ID-145875",
    name: "Coupons Name",
    count: 15,
    price: "50",
    productSize: "Bottle 1.5 L",
    refillTimes: "2 Days/Week As",
    itemPerRefill: "3 Bottle/Once",
    status: "Active",
    customer: "Customer Name",
  },
  {
    id: "ID-145876",
    name: "Coupons Name",
    count: 10,
    price: "100",
    productSize: "Gallon",
    refillTimes: "3 Days/Week",
    itemPerRefill: "1 Gallon/Once",
    status: "Pending Approval",
    customer: "Customer Name",
  },
  {
    id: "ID-145877",
    name: "Coupons Name",
    count: 15,
    price: "50",
    productSize: "Bottle 1.5 L",
    refillTimes: "2 Days/Week As",
    itemPerRefill: "3 Bottle/Once",
    status: "Active",
    customer: "Customer Name",
  },
]

export const Coupons: React.FC<CouponsProps> = ({ isDashboardPage }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const [activeTab, setActiveTab] = useState<IndexType>("list-ul")
  const [checkedCoupons, setCheckedCoupons] = useState<Coupon[]>([])
  const [coupons, setcoupons] = useState<Coupon[]>([])
  const [filteredCoupons, setFilteredCoupons] = useState<Coupon[]>([])
  const [openAddNewCouponModal, setOpenAddNewCouponModal] =
    useState<boolean>(false)
  const [openAddNewOfferModal, setOpenAddNewOfferModal] =
    useState<boolean>(false)
  const [openAddNewCompaignModal, setOpenAddNewCompaignModal] =
    useState<boolean>(false)
  const [openAutoAssignToDeliveryModal, setOpenAutoAssignToDeliveryModal] =
    useState<boolean>(false)
  const [openPendingApprovalModal, setOpenPendingApprovalModal] =
    useState<boolean>(false)
  const [selectedCoupon, setSelectedCoupon] = useState<Coupon | null>(null)

  useEffect(() => {
    setcoupons(couponsData)
    setFilteredCoupons(couponsData)
  }, [])

  const isAllChecked = useMemo(() => {
    return coupons.length > 0 && checkedCoupons.length === coupons.length
  }, [coupons, checkedCoupons])

  const togglecheckedCouponHandler = useCallback((coupon: Coupon) => {
    setCheckedCoupons(prev =>
      prev.includes(coupon) ? prev.filter(c => c !== coupon) : [...prev, coupon]
    )
  }, [])

  const toogleActiveCoupon = useCallback(
    (coupon: Coupon) => {
      // If status is Pending Approval, open the pending approval modal
      if (coupon.status === "Pending Approval") {
        setSelectedCoupon(coupon)
        setOpenPendingApprovalModal(true)
        return
      }

      setcoupons(prev =>
        prev.map(c =>
          c.id === coupon.id
            ? {
                ...c,
                status: coupon.status === "Active" ? "In Active" : "Active",
              }
            : c
        )
      )
    },
    [coupons]
  )

  const handlePendingApprovalSubmit = useCallback((couponData: any) => {
    // Update the coupon status from "Pending Approval" to "Active"
    if (selectedCoupon) {
      setcoupons(prev =>
        prev.map(c =>
          c.id === selectedCoupon.id
            ? {
                ...c,
                status: "Active",
                // Update other properties if needed from the form data
                refillTimes: `${couponData.refillTimesPerWeek} Days/Week`,
                itemPerRefill: `${couponData.itemCountPerOnce} Gallon/Once`,
              }
            : c
        )
      )
    }

    // Update filtered coupons as well
    setFilteredCoupons(prev =>
      prev.map(c =>
        c.id === selectedCoupon?.id
          ? {
              ...c,
              status: "Active",
              // Update other properties if needed from the form data
              refillTimes: `${couponData.refillTimesPerWeek} Days/Week`,
              itemPerRefill: `${couponData.itemCountPerOnce} Gallon/Once`,
            }
          : c
      )
    )

    // Close the modal
    setOpenPendingApprovalModal(false)
    setSelectedCoupon(null)
  }, [selectedCoupon])

  const toggleAllCoupons = useCallback(() => {
    setCheckedCoupons(isAllChecked ? [] : coupons)
  }, [isAllChecked, coupons])

  const addNewCouponHandler = useCallback(() => {
    setOpenAddNewCouponModal(true)
  }, [])
  const editCouponHandler = useCallback((coupon: Coupon) => {}, [])
  const deleteCouponHandler = useCallback((coupon: Coupon) => {}, [])
  const viewDetailsHandler = useCallback((coupon: Coupon) => {
    navigate(`/coupons/${coupon.id}`)
  }, [])
  const addOfferHandler = useCallback((coupon: Coupon) => {
    setOpenAddNewOfferModal(true)
  }, [])
  const addCompaign = useCallback((coupon: Coupon) => {
    setOpenAddNewCompaignModal(true)
  }, [])
  const autoAssignToDelivery = useCallback((coupon: Coupon) => {
    setOpenAutoAssignToDeliveryModal(true)
  }, [])

  if (isDashboardPage) {
    return (
      <>
        <FilterData
          data={coupons}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          bearerFilteredData={setFilteredCoupons}
          showFilterBtnInsteadOfToggle
        />

        {/* Modals */}
        <AddNewCoupon
          isOpen={openAddNewCouponModal}
          toggle={() => setOpenAddNewCouponModal(false)}
        />

        <AddNewOffer
          formSubmitedHandler={() => {}}
          isOpen={openAddNewOfferModal}
          toggle={() => setOpenAddNewOfferModal(false)}
        />

        <AddNewCampaign
          isOpen={openAddNewCompaignModal}
          toggle={() => setOpenAddNewCompaignModal(false)}
        />

        <AssignDeliveryManModal
          isOpen={openAutoAssignToDeliveryModal}
          toggle={() => setOpenAutoAssignToDeliveryModal(false)}
          order={null}
          // isAutoAssign={true}
        />

        <PendingApprovalModal
          isOpen={openPendingApprovalModal}
          toggle={() => setOpenPendingApprovalModal(false)}
          coupon={selectedCoupon}
          onSubmit={handlePendingApprovalSubmit}
        />
        <CouponsTable
          coupons={filteredCoupons}
          isAllChecked={isAllChecked}
          checkedCoupons={checkedCoupons}
          toggleAllCoupons={toggleAllCoupons}
          togglecheckedCouponHandler={togglecheckedCouponHandler}
          toogleActiveCoupon={toogleActiveCoupon}
          editCouponHandler={editCouponHandler}
          deleteCouponHandler={deleteCouponHandler}
          viewDetailsHandler={viewDetailsHandler}
          addOfferHandler={addOfferHandler}
          addCompaign={addCompaign}
          autoAssignToDelivery={autoAssignToDelivery}
        />
      </>
    )
  }

  return (
    <div className="page-content">
      <div className="container-fluid d-flex justify-content-between align-items-center">
        <Breadcrumbs
          title={t("dashboard_dashboard")}
          breadcrumbItem={t("coupons_coupons")}
        />
        <div className="d-flex gap-2">
          <Button
            onClick={addNewCouponHandler}
            className="bg-gradiant-blue border-0 text-capitalize"
          >
            {t("coupons_addNewCoupon")}
          </Button>
          <Button
            onClick={() => {}}
            className="bg-transparent border text-danger border-danger text-capitalize"
          >
            {t("coupons_deleteCoupons")}
          </Button>
        </div>
      </div>
      <FilterData
        data={coupons}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        bearerFilteredData={setFilteredCoupons}
      />

      {/* Modals */}
      <AddNewCoupon
        isOpen={openAddNewCouponModal}
        toggle={() => setOpenAddNewCouponModal(false)}
      />

      <AddNewOffer
        formSubmitedHandler={() => {}}
        isOpen={openAddNewOfferModal}
        toggle={() => setOpenAddNewOfferModal(false)}
      />

      <AddNewCampaign
        isOpen={openAddNewCompaignModal}
        toggle={() => setOpenAddNewCompaignModal(false)}
      />

      <AssignDeliveryManModal
        isOpen={openAutoAssignToDeliveryModal}
        toggle={() => setOpenAutoAssignToDeliveryModal(false)}
        order={null}
        // isAutoAssign={true}
      />

      <PendingApprovalModal
        isOpen={openPendingApprovalModal}
        toggle={() => setOpenPendingApprovalModal(false)}
        coupon={selectedCoupon}
        onSubmit={handlePendingApprovalSubmit}
      />

      {activeTab == "list-ul" ? (
        <CouponsTable
          coupons={filteredCoupons}
          isAllChecked={isAllChecked}
          checkedCoupons={checkedCoupons}
          toggleAllCoupons={toggleAllCoupons}
          togglecheckedCouponHandler={togglecheckedCouponHandler}
          toogleActiveCoupon={toogleActiveCoupon}
          editCouponHandler={editCouponHandler}
          deleteCouponHandler={deleteCouponHandler}
          viewDetailsHandler={viewDetailsHandler}
          addOfferHandler={addOfferHandler}
          addCompaign={addCompaign}
          autoAssignToDelivery={autoAssignToDelivery}
        />
      ) : (
        <CouponsGrid
          coupons={filteredCoupons}
          editCouponHandler={editCouponHandler}
          deleteCouponHandler={deleteCouponHandler}
          viewDetailsHandler={viewDetailsHandler}
          toogleActiveCoupon={toogleActiveCoupon}
          addOfferHandler={addOfferHandler}
          addCompaign={addCompaign}
          autoAssignToDelivery={autoAssignToDelivery}
        />
      )}
    </div>
  )
}
